import "./setupPublicPath";
import "./resizeObserverPollyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, Store } from "redux";
import reducer from "./reducer";
import { getConfig } from "config";
import "./index.css";
import "styles/normalize.css";
import App from "./App";
import "./getFingerPrint";
import reportWebVitals from "./reportWebVitals";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// 擴展 Window 類型
declare global {
  interface Window {
    __REDUX_STORE__?: Store;
  }
}

// 檢查是否為 UAT（含）以下環境
const isUatOrBelow = () => {
  const deployEnv = getConfig()?.DEPLOY_ENV;
  return deployEnv === "dev" || deployEnv === "stg" || deployEnv === "uat";
};

// 創建 store
const store = createStore(reducer);

// 將 store 暴露到 window，供 switchI18nDisplayMode 使用（僅在 UAT 以下環境）
if (typeof window !== "undefined" && isUatOrBelow()) {
  window.__REDUX_STORE__ = store;
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
